// src/pages/Bio.jsx
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import PhotoUploader from "../components/PhotoUploader";
import Lightbox from "../components/Lightbox";
import Foto from "../components/Foto";
import { firebaseService } from "../services/firebaseService";
import { cld } from "../services/cloudinaryService";
import fotoFallback from "../img/fotoPeril.jpg";
import { aviso } from "../components/Avisos";
import "../styles/bio.css";

export default function Bio() {
    const { currentUser } = useAuth();
    const [fotos, setFotos] = useState([]);
    const [fotoPerfil, setFotoPerfil] = useState(null);
    const [open, setOpen] = useState(-1);
    const [showUploader, setShowUploader] = useState(false);
    const [showUploaderPerfil, setShowUploaderPerfil] = useState(false);
    const [loading, setLoading] = useState(true);

    const cargarFotoPerfil = async () => {
        const data = await firebaseService.getFotoPerfil();
        setFotoPerfil(data?.url || null);
    };

    const cargarFotosFavoritas = async () => {
        setFotos(await firebaseService.getBioFotos());
    };

    useEffect(() => {
        Promise.all([cargarFotoPerfil(), cargarFotosFavoritas()]).finally(() => setLoading(false));
    }, []);

    const handleEliminarFoto = async (foto) => {
        if (!window.confirm("¿Eliminar esta foto de tus favoritas?")) return;
        const result = await firebaseService.deleteBioPhoto(foto.id);
        if (result.success) setFotos((prev) => prev.filter((f) => f.id !== foto.id));
        else aviso("No se pudo eliminar la foto", "error");
    };

    const handleEliminarFotoPerfil = async () => {
        if (!window.confirm("¿Eliminar la foto de perfil?")) return;
        const result = await firebaseService.deleteFotoPerfil();
        if (result.success) setFotoPerfil(null);
        else aviso("No se pudo eliminar la foto", "error");
    };

    const mover = async (index, delta) => {
        const nuevas = [...fotos];
        [nuevas[index], nuevas[index + delta]] = [nuevas[index + delta], nuevas[index]];
        setFotos(nuevas);
        const result = await firebaseService.updateBioPhotosOrder(nuevas);
        if (!result.success) {
            aviso("No se pudo guardar el orden", "error");
            cargarFotosFavoritas();
        }
    };

    return (
        <div className="bio-page page-top">
            <section className="bio-intro">
                <div className="bio-portrait">
                    <img
                        src={fotoPerfil ? cld(fotoPerfil, 900) : fotoFallback}
                        alt="Lorely González con su cámara"
                        className={loading ? "ph" : ""}
                    />
                    {currentUser && (
                        <div className="admin-row">
                            <button className="admin-chip" onClick={() => setShowUploaderPerfil(!showUploaderPerfil)}>
                                {fotoPerfil ? "Cambiar foto" : "Subir foto"}
                            </button>
                            {fotoPerfil && (
                                <button className="admin-chip danger" onClick={handleEliminarFotoPerfil}>Eliminar</button>
                            )}
                        </div>
                    )}
                    {showUploaderPerfil && currentUser && (
                        <PhotoUploader
                            folder="foto_perfil"
                            onUploadComplete={async () => { await cargarFotoPerfil(); setShowUploaderPerfil(false); }}
                            singleUpload={true}
                            tipo="perfil"
                        />
                    )}
                </div>

                <div className="bio-text">
                    <span className="eyebrow">Sobre mí</span>
                    <h1 className="display">Lorely<br />González</h1>
                    <p className="bio-lead">
                        Fotógrafa deportiva en CDMX. Llevo más de dos años persiguiendo el instante
                        exacto: el remate, la clavada, el golpe que cambia la pelea.
                    </p>
                    <p>
                        Me especializo en fútbol, básquet, box y tocho bandera. Mi objetivo es capturar
                        la esencia de cada deporte: la intensidad del ring, la precisión de la duela,
                        la pasión de la cancha y la velocidad del emparrillado.
                    </p>
                    <p>
                        Trabajo con equipo profesional Sony y Canon y lentes para acción, así que
                        las fotos salen nítidas aunque el juego vaya rápido o la luz sea mala.
                    </p>

                    <dl className="bio-stats">
                        <div><dt className="mono">Experiencia</dt><dd>2+ años</dd></div>
                        <div><dt className="mono">Disciplinas</dt><dd>Fútbol · Básquet · Box · Tocho</dd></div>
                        <div><dt className="mono">Equipo</dt><dd>Sony · Canon</dd></div>
                    </dl>

                    <Link to="/contacto" className="btn btn-volt">Cotiza tu evento</Link>
                </div>
            </section>

            <section className="bio-favs">
                <div className="albumes-head">
                    <h2 className="mono">Favoritas</h2>
                    {currentUser ? (
                        <div className="admin-row">
                            <button className="admin-chip" onClick={() => setShowUploader(!showUploader)}>
                                {showUploader ? "Cancelar" : "+ Agregar"}
                            </button>
                            <Link to="/admin/bio" className="admin-chip">Gestionar</Link>
                        </div>
                    ) : (
                        <span className="mono">{String(fotos.length).padStart(2, "0")}</span>
                    )}
                </div>

                {showUploader && currentUser && (
                    <PhotoUploader
                        folder="bio_fotos"
                        onUploadComplete={async () => { await cargarFotosFavoritas(); setShowUploader(false); }}
                        showDescription={true}
                        tipo="favoritas"
                    />
                )}

                {loading ? (
                    <div className="state"><div className="spinner" /></div>
                ) : fotos.length === 0 ? (
                    <div className="state">Aún no hay fotos favoritas.</div>
                ) : (
                    <div className="gallery">
                        {fotos.map((foto, i) => (
                            <div key={foto.id} className="fav">
                                <button className="gallery-item" onClick={() => setOpen(i)} aria-label={`Ver foto ${i + 1}`}>
                                    <Foto url={foto.url} alt={foto.descripcion || "Foto favorita"} />
                                </button>
                                {currentUser && (
                                    <div className="admin-row fav-actions">
                                        <button className="admin-chip" disabled={i === 0} onClick={() => mover(i, -1)} aria-label="Mover antes">←</button>
                                        <button className="admin-chip" disabled={i === fotos.length - 1} onClick={() => mover(i, 1)} aria-label="Mover después">→</button>
                                        <button className="admin-chip danger" onClick={() => handleEliminarFoto(foto)}>Eliminar</button>
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                )}
            </section>

            {open >= 0 && (
                <Lightbox photos={fotos} index={open} onChange={setOpen} onClose={() => setOpen(-1)} />
            )}
        </div>
    );
}
